import { Component, Input } from '@angular/core';
import { Iframe } from '@shared/components/iframe/iframe.model';
import { Subscription } from 'rxjs';
import { LocalLoaderComponent } from '@shared/components/loader/local-loader/local-loader.component';
import { CommonModule } from '@angular/common';
import { IframeURLPipe } from '@shared/components/iframe/iframe-url.pipe';
import { BypassSecurityTrustResourceUrl } from '@core/pipes/safe-url/safe-url.pipe';

@Component({
  selector: 'iframe-viewer',
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss',
  imports: [CommonModule, LocalLoaderComponent, IframeURLPipe, BypassSecurityTrustResourceUrl],
})
export class IframeComponent {
  @Input() iframe?: Iframe;
  subscription = new Subscription();
}
